/// <reference path="../../Administration/User/UserDialog.ts" />

namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class CompaniesUserDialog extends UserDialog {
        constructor() {
            super();
            
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);     

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            Serenity.EditorUtils.setReadOnly(this.form.CompanyId, true);
        }
    }
}